import { getContactUsInfo } from '@/api/modules/auctions.api';

export const application = {
  state: () => ({
    breadcrumb: [],
    contactInfo: {
      street: "211 Ullamcorper St Roseville",
      email: "sale@modeltheme.com",
      phoneNo: "+40 712 345 678",
      socials: [
        { icon: "facebook-f", link: "/" },
        { icon: "twitter", link: "/" },
        { icon: "linkedin", link: "/" },
        { icon: "instagram", link: "/" },
      ],
    },
    settings: {
      websiteName: "iBid",
    },
    locale: "zh-CN",
    currency: "CNY",
    currentActiveModal: "",
  }),
  mutations: {
    setLocation(state, payload) {
      state.breadcrumb = payload;
    },
    toggleModal(state, payload) {
      if (state.currentActiveModal === payload) {
        state.currentActiveModal = ""
      } else {
        state.currentActiveModal = payload;
      }
    },
    forceCloseModal(state) {
      state.currentActiveModal = "";
    },
    setContactInfo(state, payload) {
      // console.log(payload, 333333)
      state.contactInfo = { ...state.contactInfo, ...payload };
    }
  },

  actions: {
    async fetchContactInfo({ commit, state }) {
      const response = await getContactUsInfo();
      // console.log(response.data.contacts[0], 477777)
      commit('setContactInfo', response.data.contacts[0]);
    }
  },
  getters: {
    modalIsQuickView: (state) => {
      return state.currentActiveModal.includes('qv');
    },
  },
};
